import { render, staticRenderFns } from "./EmergencyOrderDetails.vue?vue&type=template&id=ef431e70&scoped=true"
import script from "./EmergencyOrderDetails.vue?vue&type=script&lang=js"
export * from "./EmergencyOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./EmergencyOrderDetails.vue?vue&type=style&index=0&id=ef431e70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef431e70",
  null
  
)

export default component.exports